<template>
    <div class="border border-tc-gray-4 flex items-center py-1 pl-1 pr-3 rounded-full cursor-pointer"
         :class="[bgClass]">
        <div class="w-8 h-8  rounded-full" :class="isActive ? 'bg-white' : 'bg-a-gray-e9ecf5'">
             <img class="w-full" :src="category.imageInactive">
        </div>
        <div class="ml-2 text-14" :class="[textClass]">{{catName}}</div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin";

export default {
    name: 'CatMenuItem',
    mixins: [LocaleMixin],
    props: {
        category: Object,
        isActive: { type: Boolean, default: false },
    },
    computed: {
        catName: function() {
            return this.localeCode == 1033 ? this.category.nameEn : this.category.nameTh;
        },
        bgClass: function() {
            if (this.isActive) {
                return 'bg-tc-blue-1';
            }
            return 'bg-white';
        },
        textClass: function() {
            if (this.isActive) {
                return 'text-white';
            }
            return 'text-tc-blue-1';
        },
    },
    methods: {

    },
}
</script>
<style lang="scss" scoped>
</style>
